import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { CategoryService } from '../../services/category/category.service';
import { SectionsEnum } from '../../enums/sections.enum';
import { PublishStatusEnum } from '../../enums/publishStatus.enum';

@Injectable({
  providedIn: 'root'
})

export class EditCategoryGuard implements CanActivate {

  constructor(
    private categoryService: CategoryService,
    private router: Router,
    private authService: AuthService
  ) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const categoryId = route.paramMap.get('id');
    const categorySection = route.queryParamMap.get('categorySection');
    const isTranslationsRoute = state.url.includes('/translations');

    if (!categoryId) {
      return true;
    }

    const category = await this.categoryService.getById(categoryId, this.authService.projectId);

    if (category?.assigned && category?.status === PublishStatusEnum.PUBLISHED
      && categorySection !== SectionsEnum.TRANSLATIONS && !isTranslationsRoute) {
      this.router.navigate(['/categories']);
      return false;
    }
    return true;
  }
}
